module.exports = __webpack_public_path__ + "img/uranium-ore-glow.03adc7d4.png";